import { memo } from 'react';

import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

import { colors } from '../../assets';
import { useStyles } from './UserIdentifier.styles';
import { UserIdentifierProps } from './UserIdentifier.types';
import { stringAvatar } from './UserIdentifier.utils';

export const UserIdentifier = memo(
  ({
    name,
    imageUrl,
    size = 'large',
    isDisplayName = true,
    isUnderlineName = false,
    className,
    classes,
    color,
  }: UserIdentifierProps) => {
    const styles = useStyles();

    if (!name || name.length <= 1) {
      return (
        <div style={{ color: colors.grey140 }}>
          <Typography>Unassigned</Typography>
        </div>
      );
    }

    return (
      <Grid
        container
        spacing={1}
        className={clsx(styles.container, 'MuiSpacingWidthAuto', className, classes?.rootContainer)}
        wrap="nowrap"
      >
        <Grid item className={classes?.avatarContainer}>
          <Avatar
            alt={name}
            {...stringAvatar(name.split(' ')[0] || name, imageUrl)}
            src={imageUrl}
            className={clsx(
              styles.avatar,
              classes?.avatar,
              size === 'small' && 'small',
              size === 'medium' && 'medium',
              size === 'large' && 'large',
            )}
          />
        </Grid>
        {isDisplayName && (
          <Grid item className={classes?.usernameContainer}>
            <div style={{ color: color }}>
              <Typography
                variant="body1"
                color="inherit"
                className={clsx(
                  styles.name,
                  size === 'small' && 'small',
                  size === 'medium' && 'medium',
                  size === 'large' && 'large',
                  isUnderlineName && styles.underlineName,
                  classes?.username,
                )}
              >
                {name}
              </Typography>
            </div>
          </Grid>
        )}
      </Grid>
    );
  },
);
